import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-member-creation',
  templateUrl: './member-creation.component.html',
  styleUrls: ['./member-creation.component.css']
})
export class MemberCreationComponent implements OnInit {

  title = "Member Creation";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/accountmaster/member-creation/member-creation.component.ts